var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXCircleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#CB4938"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15709 18.7487C6.92487 18.7487 6.69266 18.6601 6.51559 18.4831C6.16147 18.1289 6.16147 17.5546 6.51559 17.2001L17.2014 6.51462C17.5555 6.16049 18.1299 6.16049 18.4844 6.51462C18.8385 6.86874 18.8385 7.44311 18.4844 7.7976L7.79821 18.4831C7.62115 18.6601 7.3893 18.7487 7.15709 18.7487Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8426 18.749C17.6103 18.749 17.3781 18.6605 17.2011 18.4834L6.51559 7.7976C6.16147 7.44347 6.16147 6.86911 6.51559 6.51462C6.86972 6.16049 7.44409 6.16049 7.79858 6.51462L18.4844 17.2004C18.8385 17.5546 18.8385 18.1289 18.4844 18.4834C18.307 18.6605 18.0748 18.749 17.8426 18.749Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircleRed);
export default __webpack_public_path__ + "static/media/x-circle-red.1709fafee28884ad4f9391b1f6194182.svg";
export { ForwardRef as ReactComponent };